<template>
  <FormItem :label="label" :prop="$attrs.name">
    <Select 
      ref="formInput"
      v-bind="$attrs"
      v-on="$listeners"
      :id="$attrs.name"
    >
      <Option
        v-for="(item, index) in items"
        :key="`${item}-${index}`"
        :value="item[valuePath] || item"
        :disabled="item.disabled"
      >
        {{ item[labelPath] || item }}
      </Option>
    </Select>
  </FormItem>
</template>

<script>
import resourceNamePluralizer from "@/utils/resource-name-pluralizer";
import { Select, FormModel } from "ant-design-vue";
import { mapGetters } from "vuex";

const { Option } = Select;

const STORE_KEY = "searchStore";

export default {
  data() {
    return {
      dropdownItems: [],
      searchKey: ""
    }
  },
  props: {
    resource: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      required: true
    },
    valuePath: {
      type: String,
      default: "Id"
    },
    labelPath: {
      type: String,
      default: "name"
    },
    clearable: {
      type: Boolean,
      default: false
    },
    filterByLabel: {
      type: Array,
      default: () => []
    }
  },
  components: {
    Select,
    Option,
    FormItem: FormModel.Item
  },
  computed: {
    ...mapGetters({
      countries: `${STORE_KEY}/countries`
    }),

    items() {
      return  this.dropdownItems;
    }
  },
  async mounted() {
    await this.$store.dispatch(`${STORE_KEY}/getSortedTaxonomy`, {
      storeKey: resourceNamePluralizer.get(this.resource),
      loadingKey: `${resourceNamePluralizer.get(this.resource)}Loading`,
      type: this.type
    });
    this.dropdownItems = [...this[resourceNamePluralizer.get(this.resource)]]
  },

};
</script>

<style></style>
